import * as React from 'react'
import { IntlProvider } from 'react-intl'
import { Props } from './contentAuditSuspectsState'
import { root } from './contentAuditSuspectsWidgets'

export default (props: Props): JSX.Element => (
  <IntlProvider locale={window.Gites.locale}>
    {root(props).run(_ => null)}
  </IntlProvider>
)
